import router from '../../router';

const funcObj = {
  toDecimal: function (val) {
    let type = Object.prototype.toString.call(val);
    if (type === '[object Undefined]' || type === '[object Null]') return '暂无';
    let value = val.toString();
    if (value.indexOf('.') > 0) {
      let decimal = value.substr(value.indexOf('.') + 1, value.length);
      let number = value.substr(0, value.indexOf('.'));
      if (decimal.length === 1) {
        return value + '0'
      } else if (decimal.length === 2) {
        return value
      } else if (decimal.length >= 3) {
        var new_value = parseFloat(value).toFixed(3);
        return new_value.substr(0, new_value.length - 1);
      }
    } else {
      return value + '.00'
    }
  },

  filterDate: function (date) {
    if (date.indexOf(' ') > 0) {
      var spaceIndex = date.indexOf(' ');
      return date.substr(0, spaceIndex);
    }
    return date
  },//删除详情时间参数

  clacDaysSpan: function clacDaysSpan(start_at, end_at) {
    let arr_start_at, arr_end_at, new_start_at, new_end_at, spanDays,
      cur_start_at = filterDate(start_at),
      cur_end_at = filterDate(end_at);

    arr_start_at = cur_start_at.split('-');
    arr_end_at = cur_end_at.split('-');
    new_start_at = new Date(`${arr_start_at[1]}/${arr_start_at[2]}/${arr_start_at[0]}`);
    new_end_at = new Date(`${arr_end_at[1]}/${arr_end_at[2]}/${arr_end_at[0]}`);

    spanDays = parseInt(Math.abs(new_start_at - new_end_at) / 1000 / 60 / 60 / 24);
    return spanDays
  },

  changedUnit: function (val, needUnit) {
    let type = Object.prototype.toString.call(val);
    if (type === '[object Undefined]' || type === '[object Null]') return '暂无';
    let newVal = val;
    if (needUnit) {
      val >= 1024 ? newVal = `${toDecimal(val / 1024)}/G` : newVal = `${toDecimal(val)}/M`;
    } else {
      val >= 1024 ? newVal = toDecimal(val / 1024) : newVal = toDecimal(val);
    }
    return newVal
  },

  navigateTo: function (path, type = 1, query, params) {
    if (type == 1) {
      router.push({
        path,
        params,
        query
      })
    } else {
      location.href = path
    }
  }
}

export default {
  install: function (Vue, options) {
    for (let key in funcObj) {
      Vue.prototype[key] = (...val) => funcObj[key](...val)
    }
  }
}
